"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
exports.isExpanded = function (pathId, selectedPath) {
    if (pathId && selectedPath) {
        var selectedPathArr = selectedPath.split(constants_1.PATH_SEPARATOR);
        var pathIdArr = pathId.split(constants_1.PATH_SEPARATOR);
        // if they have same parent
        return (pathIdArr[0] === selectedPathArr[0]);
    }
    return false;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-sidenav/nav/isExpanded.js
// module id = ./node_modules/react-sidenav/nav/isExpanded.js
// module chunks = 0